export enum OrderStatus {
  TO_ORDER = "TO_ORDER",
  BOOKING_IN_PROGRESS = "BOOKING_IN_PROGRESS",
  CHANGE_REQUIRED = "CHANGE_REQUIRED",
  INITIAL = "INITIAL",
  CONFIRMED = "CONFIRMED",
  FOR_ADVANCE_PAYMENT = "FOR_ADVANCE_PAYMENT",
  ADVANCE_PAID = "ADVANCE_PAID",
  LIST_SENT = "LIST_SENT",
  CHECKED_IN = "CHECKED_IN",
  PAID = "PAID",
  TO_CANCEL = "TO_CANCEL",
  CANCELLATION_SENT = "CANCELLATION_SENT",
  CANCELLED = "CANCELLED",
  TO_MOVE = "TO_MOVE",
}

export const CostStatusColors = {
  NOT_PAID: "white",
  ADVANCE_PAYMENT: "#00ff00",
  PAID: "#6fa8dc",
  TO_CORRECT: "#ff9933",
};

export type Currency = "EUR" | "PLN";

export type ID = string;

export enum DisplayMode {
  NORMAL = "NORMAL",
  HISTORICAL = "HISTORICAL",
  WARNING = "WARNING",
  OVERDUE = "OVERDUE",
}
